export default {
  checkPermissions(allowedPermissions) {
    const permissions = JSON.parse(localStorage.permissions);
    if (permissions.includes('owner')) {
      return true;
    }
    if (allowedPermissions.length === 0) {
      return true;
    }
    return allowedPermissions.every(element => permissions.includes(element));
  },
  checkPermissionsOnArray(arrayToBeFiltered) {
    return arrayToBeFiltered.filter(item => this.checkPermissions(item.permissions));
  },
};



// WEBPACK FOOTER //
// ./src/libs/permissions.js